<template>
	<div
		@click="!hidePopupFirst ? hide() : hideSecond()"
		v-if="!hidePopup && isMobile"
	>
		<b-overlay
			:show="!hidePopup && isMobile"
			class="first-login-overlay"
			spinner-type="false"
			rounded="true"
			variant="outline-success"
			:opacity="0.76"
			:blur="'5px'"
		>
			<div class="icondiv" v-if="!hidePopupFirst">
				<ViewDashboardIcon />
			</div>
			<div class="text" v-if="!hidePopupFirst">
				<span>{{ $t('Recommended use') }}</span>
				<div style="color:white;">{{ $t('button back to control panel') }}</div>
			</div>
			<button
				v-if="!hidePopupSecond"
				id="addListing"
				class="icondiv-addlisting btn-post"
			>
				<IconListAdd />
				{{ $t('addListing.name') }}
			</button>

			<div class="add-buttontext" v-if="!hidePopupSecond">
				<span>{{ $t('Recommended use') }}</span>
				<div style="color:white;">{{ $t('Post your product here') }}</div>
			</div>
		</b-overlay>
	</div>
</template>
<script>
// Icons
import ViewDashboardIcon from 'vue-material-design-icons/ViewDashboard.vue';
import IconListAdd from '@/components/icons/IconListAdd/index';

import { mapGetters } from 'vuex';
import $ from 'jquery';

export default {
	name: 'CheckUserFirstLogin',
	components: {
		ViewDashboardIcon,
		IconListAdd
	},
	data() {
		return {
			hidePopup: true,
			hidePopupFirst: false,
			hidePopupSecond: true
		};
	},
	created() {
		let first_time_login = JSON.parse(localStorage.getItem('first_time_login'));
		if (first_time_login.show_overlay) {
			this.hidePopup = false;
			this.addOverFlowInWindow();
		}
		let user = JSON.parse(localStorage.getItem('user_profile'));
		if (user && user.id) {
			localStorage.setItem(
				'first_time_login',
				JSON.stringify({ id: user.id, show_overlay: false })
			);
		}
	},
	computed: {
		...mapGetters('UserController', ['isMobile'])
	},
	methods: {
		hide() {
			this.hidePopupFirst = true;
			this.$forceUpdate();
			this.hidePopupSecond = false;
			this.$forceUpdate();
		},
		hideSecond() {
			this.hidePopupSecond = true;
			this.$forceUpdate();
			this.hidePopup = true;
			this.$forceUpdate();

			document.getElementsByTagName('body')[0].style = 'overflow: auto';
		},
		addOverFlowInWindow() {
			setTimeout(() => {
				document.getElementsByTagName('body')[0].style = 'overflow: hidden';
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.first-login-overlay {
	position: absolute !important;
	width: 100%;
	height: 100%;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: 9999;
	background: #000000ab;
	.first-div{
		width: 100%;
		position: absolute;
		top: 0px;
        .second-div{
			opacity: 1;
			pointer-events: all;
			visibility: visible;
			z-index: 2147483647;    
			height: 100%;    
			transition: opacity 0.3s ease 0s;
 			.third-div{
				display: -webkit-box;
				display: -webkit-flex;
				display: -ms-flexbox;
				display: flex;
				position: relative;
				.fourth-div{
					opacity: 1;
					pointer-events: all;
					visibility: visible;
					z-index: 2147483647;
					.fifth-div{
						text-align: left;
						position: absolute;
						z-index: 2147483647;
						pointer-events: none;
						top: 153px;
    					right: 86px;
					}
					.sixth-div{
						text-align: left;
						position: absolute;
						z-index: 2147483647;
						pointer-events: none;
						top: 154px;
						right: -13px;
					}
				}
			}
	  	}
	}




	.switchDashboardButton{
		color: white;    
		border: 1px solid white;
		border-radius: 100px;
		font-size: 16px;
		padding: 4px 12px;
		box-shadow: 0px 3px 6px #00000029;
		margin: 0 5px;
		span{
		font-size: 14px;
		}
		&:focus{
		border: 1px solid white!important;
		box-shadow: 0px 3px 6px #00000029!important;
		}
	}
	.icondiv {
		z-index: 999;
		bottom: 0;
		right: 0px;
		top: 114px;
		position: absolute;
		background: #fff;
		width: 50px;
		height: 50px;
		.view-dashboard-icon {
			fill: var(--projectPrimaryColor) !important;
			top: 50%;
			bottom: 0;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 20px;
			color: var(--projectPrimaryColor);
		}
	}
	.text {
		z-index: 999;
		bottom: 0;
		right: 5px;
		top: 168px;
		position: absolute;
		span {
			color: #00b400;
			font-size: 16px;
		}
	}
	.add-buttontext {
		z-index: 999;
		bottom: 0;
		right: 37px;
		top: 120px;
		position: absolute;
		span {
			color: #00b400;
			font-size: 16px;
		}
	}
	.btn-post {
		font-size: 20px;
		color: #fff;
		background: var(--projectPrimaryColor);
		width: 41%;
		padding: 14px 0;
		border: none;
		height: calc(1.5em + 0.75rem + 8px) !important;
		z-index: 999;
		bottom: 0;
		right: 19%;
		top: 55px;
		position: absolute;
		.magnify-icon {
			> svg {
				margin-bottom: 5px;
				margin-right: 8px;
				fill: white;
				path {
					fill: white;
				}
				&.icon-list-add {
					filter: invert(1);
				}
			}
		}
	}
}
</style>
